import { Injectable } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { OpenDialogModalComponent } from '../components/openDialogModal.component'

export interface OpenDialogOptions {
  title?: string
  path?: string
  relative?: string
  root?: string
  confineToRoot?: boolean
  globMode?: boolean
}

@Injectable({ providedIn: 'root' })
export class OpenDialogService {
  constructor (private ngbModal: NgbModal) { }

  async show (options?: OpenDialogOptions): Promise<string> {
    options ??= {}
    const m = this.ngbModal.open(OpenDialogModalComponent, {
      size: 'lg',
    })
    m.componentInstance.options = options
    return m.result
  }
}
